import { useAuth } from '@/hooks/useAuth';
import { commonAPI, useAppSelector, useSelectedOrganisation } from '@/store';

export const useUserPermissions = () => {
  const org = useSelectedOrganisation();
  const { user, isAuthenticated, isLoading: isAuthLoading } = useAuth();

  const authReady = isAuthenticated && !!user;

  const { isLoading: isTreeLoading } = commonAPI.usePermissionsGetPermissionTreeQuery(undefined, {
    skip: !authReady,
  });

  const req = { organisationId: org?.id ?? '' };

  const { error } = useAppSelector(commonAPI.endpoints.permissionsGetPermissionsByOrgId.select(req)) as any;

  const skip = !authReady || !org?.id;

  const { data, isFetching } = commonAPI.usePermissionsGetPermissionsByOrgIdQuery(req, {
    skip: skip || !!error,
  });

  const isLoading = isAuthLoading || (authReady && isTreeLoading) || isFetching;

  return { permissions: data?.map((el: any) => el.shortCode ?? ''), isLoading };
};
